import { render, staticRenderFns } from "./ResultSetViewer.vue?vue&type=template&id=06393cb5"
import script from "./ResultSetViewer.vue?vue&type=script&lang=ts"
export * from "./ResultSetViewer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports